module.exports = __webpack_public_path__ + "img/types.e936e6a3.svg";